module.exports = __webpack_public_path__ + "static/media/section-reporting-disabled.882753be.svg";